/**
 * 同步订单
 */
 const state = {
  storageId: 0 || sessionStorage.getItem("storageId"), // 店铺id
  goodsData: null || JSON.parse(sessionStorage.getItem("goodsData")) // 商品
};

const getters = {
  storageId: state => state.storageId,
  goodsData: state => state.goodsData
};

const mutations = {
  SET_STORAGE_ID: (state, payload) => {
    sessionStorage.setItem("storageId", payload);
    state.storageId = payload;
  },
  SET_GOODS_DATA: (state, payload) => {
    sessionStorage.setItem("goodsData", JSON.stringify(payload));
    state.goodsData = payload;
  }
};

export default {
  state,
  getters,
  mutations,
  namespaced: true
};
